import React from 'react';
import { Rating, Box } from '@mui/material';
import { DetailSection, SectionTitle, FeedbackContainer, InfoValue } from './styles';

interface FeedbackProps {
  rating: number;
  comment: string;
}

const Feedback: React.FC<FeedbackProps> = ({ rating, comment }) => {
  return (
    <DetailSection>
      <SectionTitle>Feedback</SectionTitle>
      <Box sx={{ mb: 1 }}>
        <Rating value={rating} readOnly />
      </Box>
      <FeedbackContainer>
        <InfoValue sx={{ fontSize: '0.95rem', color: '#444' }}>
          {comment || "No feedback provided."}
        </InfoValue>
      </FeedbackContainer>
    </DetailSection>
  );
};

export default Feedback;
